import React from 'react';
import StripePaymentForm from "../../services/stripe/components/StripePaymentForm.jsx";
import styled from "styled-components";

const PaymentSectionContainer = styled.section`
    padding: 50px 0;
    width: 100%;
`
const PaymentSectionComponent = ({product, quantity = 1}) => {


    return (
        <PaymentSectionContainer>
            <StripePaymentForm    />
        </PaymentSectionContainer>
    );
};

export default PaymentSectionComponent;